import { useEffect, useState } from 'react';

const seen = new Set<string>();

/**
 * True for the first component to mount with `key` in this page load, false for every later mount —
 * e.g. an intro animation that shouldn't replay when the user navigates back to the screen.
 *
 * The answer is fixed for the life of the component, so StrictMode's double render and effect replay
 * don't flip it. Only a full page load resets it.
 */
export const useOncePerPageLoad = (key: string): boolean => {
  const [first] = useState(() => !seen.has(key));

  useEffect(() => {
    seen.add(key);
  }, [key]);

  return first;
};

/** Forgets every key. Tests only. */
export const resetOncePerPageLoad = (): void => seen.clear();
